import { render, staticRenderFns } from "./InformacionGeneralForm.vue?vue&type=template&id=fea15c7e&scoped=true&"
import script from "./InformacionGeneralForm.vue?vue&type=script&lang=js&"
export * from "./InformacionGeneralForm.vue?vue&type=script&lang=js&"
import style0 from "./InformacionGeneralForm.vue?vue&type=style&index=0&id=fea15c7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea15c7e",
  null
  
)

export default component.exports